import { createContext } from 'react';
import { PORTAL_TYPE } from '@trnsact/trnsact-shared-types';

interface CommonDataContextInterface {
  isDealerUser: boolean;
  isLenderUser: boolean;
  isAftermarketPartner: boolean;
  isCommonPartner: boolean;
  portalType: PORTAL_TYPE;
}

export const CommonDataContext = createContext<CommonDataContextInterface>({
  isDealerUser: false,
  isLenderUser: false,
  isAftermarketPartner: false,
  isCommonPartner: false,
  portalType: 1,
});
